import { useCallback, useState } from 'react';
//
export default function PayTypeModel() {
  // 推送内容
  const [showPayType, setShowPayType] = useState<any>({});
  const setShowPayTypeCb = useCallback((val) => {
    setShowPayType(val);
  }, []);
  return {
    showPayType,
    setShowPayTypeCb,
  };
}
